import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import * as React from 'react';
import LearningPartnersStore from '../../../../LearningPartnersStore';
import LearningPartnersReactions from '../../../../LearningPartnersStore/LearningPartnersReactions';
import { LearningPartnersResource } from '../../../../LearningPartnersStore/Types';
import { ProgramDetailResource } from '../../../../ProgramStore/Types';
import * as style from '../../../ProgramSummary/style.module.css';
import LearningPartnerBody from '../LearningPartnersPanel/LearningPartnerBody';
import LearningPartnersDashboardHeader from './LearningPartnersDashboardHeader';

interface Props {
  programDetailResource: ProgramDetailResource;
}

@observer
class LearningPartnersDashboard extends React.Component<Props, {}> {
  private learningPartnersStore: LearningPartnersStore;

  constructor(props: Props) {
    super(props);
    this.learningPartnersStore = new LearningPartnersStore();
  }

  componentDidMount() {
    this.learningPartnersStore.loading(this.props.programDetailResource);
  }

  render() {
    return (
      <>
        {this.learningPartnersStore.learningPartners
          .assign<'resource', LearningPartnersResource>('resource', just)
          .assign('learningPartners', ({ resource }) => fromArrayMaybe(resource.payload))
          .map(({ learningPartners, resource }) => (
            <dl className={style.dl}>
              <LearningPartnersDashboardHeader learningPartners={learningPartners} />
              <LearningPartnerBody learningPartnersResource={resource} />
            </dl>
          ))

          .getOrElseValue(<span />)}
        <LearningPartnersReactions
          store={this.learningPartnersStore}
          resourceWithLearningPartners={this.props.programDetailResource}
        />
      </>
    );
  }
}

export default LearningPartnersDashboard;
